import {Outlet} from "react-router-dom";
import {Box} from "@mui/material";
import {useDocumentMeta} from "@bounce/shared/hooks";
import {urls} from "routes/urls";

const BackofficeLayout = () => {
  useDocumentMeta({urls, favicon: "/spring-favicon.svg", titlePrefix: "Backoffice"});

  return (
    <Box sx={{display: "flex", minHeight: "100vh"}}>
      <Outlet />
    </Box>
  );
};

export default BackofficeLayout;
